import { render, staticRenderFns } from "./macaoInventoryRecord.vue?vue&type=template&id=f126c8a8&scoped=true"
import script from "./macaoInventoryRecord.vue?vue&type=script&lang=js"
export * from "./macaoInventoryRecord.vue?vue&type=script&lang=js"
import style0 from "./macaoInventoryRecord.vue?vue&type=style&index=0&id=f126c8a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f126c8a8",
  null
  
)

export default component.exports